import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { selectDefaultCreationEnvironment } from '../environments/environmentsReducer';
import LoadingSweep from '../../common/LoadingSweep';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import useSweepNavigate from '../../../navigation-utils/useSweepNavigate';
import { addCrmOrgIdToPath } from '../../../navigation-utils/urlOrgUtils';
import { selectUserAccountId } from '../../../reducers/userInfoReducer';

export const RedirectToDefaultEnv = () => {
  const { navigate } = useSweepNavigate();
  const defaultCreationEnv = useSelector(selectDefaultCreationEnvironment);
  const userAccountId = useSelector(selectUserAccountId);
  const { pathname } = useLocation();

  const targetPath = userAccountId
    ? addCrmOrgIdToPath(pathname, userAccountId, defaultCreationEnv?.id)
    : undefined;

  useRunOnceWhenTruthy(() => {
    // Redirect to the default creation environment
    // We can assume this is loaded by the global fetcher
    if (targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, !!targetPath);

  return <LoadingSweep />;
};
